<template>
  <div class="nav-collection-editor-page">
    <div class="grid-9 grid-column-gap-0">
      <div class="sidebar-wrapper span-2">
        <slot />
      </div>
      <div class="span-7 span-9-sm page-content" v-if="algoliaCollections">
        <h2 class="font-size-48">Nav Collections</h2>
        <nav-collection-item-editor
          v-for="childrenContainer of childrenContainers"
          :parent-container-id="featuredCollectionParent.id"
          :algolia-collections="algoliaCollections"
          :children-container="childrenContainer"
        />

        <nav-collection-item-editor
          v-for="childrenContainer of newChildrenContainers"
          :algolia-collections="algoliaCollections"
          :parent-container-id="featuredCollectionParent.id"
          :children-container="childrenContainer"
          :created="removeNewChildrenContainers"
        />

        <bulletin-button @click="addNewSection" :disabled="addNewSectionDisabled" full-width class="margin-top-40"
          >+ Add New Section</bulletin-button
        >
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.page-content {
  padding-inline: 24px;
}
</style>

<script>
import NavCollectionItemEditor from "@/views/dashboard/contentManagment/navCollectionEditorPage/navCollectionItemEditor";
import { mapGetters } from "vuex";
import { algoliaCollectionHelper } from "@/components/mixin/search/algoliaCollectionHelper";
import { v4 as uuid } from "uuid";

const SECTION_LIMIT = 7;

export default {
  mixins: [algoliaCollectionHelper],
  components: {
    NavCollectionItemEditor,
  },
  data: function () {
    return {
      algoliaCollections: null,
      newChildrenContainers: [],
    };
  },
  computed: {
    ...mapGetters({
      navigationData: "navigation/navigationData",
    }),
    featuredCollectionParent() {
      return this.navigationData?.children_containers?.find((item) => item.name === "Featured");
    },
    childrenContainers() {
      return this.featuredCollectionParent?.children_containers || [];
    },
    addNewSectionDisabled() {
      return (this.childrenContainers?.length || 0) + (this.newChildrenContainers?.length || 0) >= SECTION_LIMIT;
    },
  },
  mounted() {
    this.getCollections();
  },
  methods: {
    getCollections,
    addNewSection,
    removeNewChildrenContainers,
  },
};

async function getCollections() {
  this.algoliaCollections = await this.getAllCollections();
}

function addNewSection() {
  const newViewContainer = {
    name: "",
    ordinal: this.childrenContainers.length + 1,
    children_containers: [
      {
        view_components: [
          {
            localId: uuid(),
            entity_id: undefined,
            info: {
              text: "",
            },
          },
        ],
      },
      {
        view_components: [
          {
            localId: uuid(),
            entity_id: undefined,
            info: {
              text: "",
              link: "",
              image_url: "",
              layout: "IMAGE",
            },
          },
          {
            localId: uuid(),
            entity_id: undefined,
            info: {
              text: "",
              link: "",
              image_url: "",
              layout: "IMAGE",
            },
          },
          {
            localId: uuid(),
            entity_id: undefined,
            info: {
              text: "",
              link: "",
              image_url: "",
              layout: "IMAGE",
            },
          },
        ],
      },
    ],
  };

  this.newChildrenContainers.push(newViewContainer);
}

function removeNewChildrenContainers() {
  this.newChildrenContainers = [];
}
</script>
